<template>
  <v-layout class="wrapper" justify-space-between>
    <v-layout align-center>
      <v-btn icon style="margin: 0" @click="$emit('clear')">
        <v-icon color="white"> clear </v-icon>
      </v-btn>
      <div class="pointer" />
      <div v-if="selected.length === 1">
        <span class="text">{{ selected.length }} attendee selected</span>
      </div>
      <div v-else>
        <span class="text">{{ selected.length }} attendees selected</span>
      </div>
    </v-layout>
    <v-layout justify-end align-center>
      <v-tooltip v-if="trialLimitExceeded" left color="#979797">
        <main-button v-if="isDesktop" slot="activator" flat depressed disabled text="Accept" />
        <button v-else slot="activator" flat depressed disabled>
          <v-icon>done</v-icon>
        </button>
        <span>You can create up to 20 accreditations in trial version</span>
      </v-tooltip>
      <div v-else>
        <main-button depressed class="desktop-button" text="Accept" @click="$emit('accept')" />
        <v-btn icon class="hide" @click="$emit('accept')">
          <v-icon color="white">done</v-icon>
        </v-btn>
      </div>
      <main-button depressed class="desktop-button" text="deny" @click="$emit('deny')" />
      <v-btn icon class="hide" @click="$emit('deny')">
        <v-icon color="white">do_not_disturb</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'selected-requests-header',
  props: {
    selected: Array,
    user: Object,
    attendees: Array,
    totalAcceptedAttendeeCount: Number,
  },
  data() {
    return {
      isDesktop: false,
    }
  },
  computed: {
    trialLimitExceeded() {
      if (this.user.type !== 'TRIAL') return false

      return this.totalAcceptedAttendeeCount + this.selected.length > 20
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.isDesktop = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.isDesktop = true
      } else {
        this.isDesktop = false
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  color: white;
  margin: 0 0 2px 0;
  padding: 14px 10px;
  background-color: #0277bd;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 56px;
  position: relative;
}
.text {
  font-family: Raleway;
  font-size: 16px;
  font-weight: bold;
}
.pointer {
  position: relative;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #0277bd;
  top: 30px;
  right: 30px;
}
</style>
